import { InternalAxiosRequestConfig } from 'axios';
import { registerPreviewDispatcher } from '@/common/AxiosClient';
import { dispatchMock } from './mockBackend';
import { isPreviewArmed } from './previewMode';

// Bridges the fail-closed mock backend to the core axios adapter hook. Returns null when preview
// is NOT armed, so the real network adapter runs unchanged for normal users; returns the mock
// promise when armed, so the real API is never reached.
const previewDispatch = (config: InternalAxiosRequestConfig) =>
  isPreviewArmed() ? dispatchMock(config) : null;

let enabled = false;

/** Idempotently register the preview mock with the core axios client. Safe to call repeatedly. */
export function enablePreviewMock(): void {
  if (enabled) return;
  registerPreviewDispatcher(previewDispatch);
  enabled = true;
}
